import { render, staticRenderFns } from "./base-common.vue?vue&type=template&id=7042ff4c&scoped=true&"
import script from "./base-common.vue?vue&type=script&lang=js&"
export * from "./base-common.vue?vue&type=script&lang=js&"
import style0 from "./base-common.vue?vue&type=style&index=0&id=7042ff4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7042ff4c",
  null
  
)

export default component.exports